import { useState } from 'react'
import styled from '@emotion/styled'
import { Accordion, AccordionSummary } from '@mui/material'
import { ChevronDown } from '@emotion-icons/fa-solid/ChevronDown'
import { Colors, Shapes } from 'src/components/theme'

const StyledAccordion = styled(Accordion)`
  height: auto;
  background-color: ${Colors.bgWhite};
  border-radius: ${Shapes.borderRadius}px;
  border: 1px solid ${Colors.border};
  box-shadow: none;
  padding: 0;
  margin: 0 !important;
  & > .MuiButtonBase-root,
  & > .MuiButtonBase-root.Mui-expanded {
    min-height: 0;
  }
`
const StyledAccordionSummary = styled(AccordionSummary)`
  height: auto;
  min-height: 0;
  padding: ${Shapes.spacing[4]}px;
  .MuiAccordionSummary-content,
  .MuiAccordionSummary-content.Mui-expanded {
    height: auto;
    min-height: 0;
    margin: 0;
    padding: 0;
  }
`
const StyledAccordionDetails = styled.div`
  margin: ${Shapes.spacing[0]}px;
`

type PropertyRecordAccordionProps = {
  title: React.ReactNode
  content: React.ReactNode
  noContentPadding?: boolean
}
export const PropertyRecordAccordion = (props: PropertyRecordAccordionProps) => {
  const { title, content, noContentPadding } = props
  const [expanded, setExpanded] = useState(true)

  return (
    <StyledAccordion onChange={() => setExpanded(!expanded)} expanded={expanded}>
      <StyledAccordionSummary
        expandIcon={<ChevronDown size={14} />}
        aria-controls="panel1a-content"
        id="panel1a-header">
        {title}
      </StyledAccordionSummary>
      <StyledAccordionDetails
        style={{
          padding: noContentPadding ? 0 : Shapes.spacing[4],
        }}>
        {content}
      </StyledAccordionDetails>
    </StyledAccordion>
  )
}
